









































































import ToTopPage from '@/components/molecules/ToTopPage.vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import UserService from '@spa/services/api/user'

import BehaviorConfig from '@/models/app-config/behavior/behavior'

@Component({
  components: {
    ToTopPage,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ForgotPassword extends Mixins<PluginMixin & HlAppModeMixin>(PluginMixin, HlAppModeMixin) {
  status: Status = Status.Pending
  errorMessageFromAPI: string | null = null
  showModal: boolean = false

  form: {
    email: string | null,
  } = {
    email: null,
  }

  userService = new UserService()

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get behavior(): BehaviorConfig {
    return BehaviorConfig.createFromBrand(null)
  }
  get mailDomain(): string {
    return this.behavior.mailDomain
  }

  get isCompleted(): boolean {
    return this.status === Status.Completed
  }

  get resetedAddress(): string | null {
    return this.form.email
  }

  get errorMessageHTML(): string {
    return this.errorMessageFromAPI ||
      'パスワード再設定用のメール送信に失敗しました。<br/>お手数ですがカスタマーサポートまでご連絡ください。'
  }

  async validateForm(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async submit() {
    const validated = await this.validateForm()

    if (!validated) {
      return
    }

    this.errorMessageFromAPI = null
    this.status = Status.Loading

    const result = await this.userService.sendPasswordResetEmail(this.form.email!)
    result.fold(
      (error) => {
        this.errorMessageFromAPI = error && error.display_message || null
        this.status = Status.Failed
        this.showModal = true
      },
      () => {
        this.status = Status.Completed
      }
    )
  }
}
